import * as numbers from "common/numbers";

const isUsable = (value) => typeof value === "number" && !isNaN(value);

// Renders a cession band in the "$3m xs $2m" shorthand underwriters use:
// the ceded limit (to - from) in excess of the attachment (from). Returns
// null unless both ends are numbers, so callers can hide the caption. There
// is deliberately no from <= to check: a half-entered range must not block
// typing, and an inverted band simply reads back as a negative limit.
export const formatCession = (from, to, { symbol = "$" } = {}) => {
  if (!isUsable(from) || !isUsable(to)) {
    return null;
  }
  return `${symbol}${numbers.abbreviated(
    to - from
  )} xs ${symbol}${numbers.abbreviated(from)}`;
};

// Builds the account name RRRe write on a submission, in the order of their
// account hierarchy: "Clear Blue - TPM $3m xs $2m". Whatever is missing is
// skipped, so a half-entered cession still yields a usable name, and the
// result is null when nothing is entered at all.
export const formatAccountName = ({
  reinsured,
  mga,
  cessionLimitFrom,
  cessionLimitTo,
} = {}) => {
  const parties = [reinsured, mga]
    .map((value) => (typeof value === "string" ? value.trim() : ""))
    .filter(Boolean)
    .join(" - ");
  const band = formatCession(cessionLimitFrom, cessionLimitTo);
  const name = [parties, band].filter(Boolean).join(" ");
  return name || null;
};
